import { useTranslation } from 'react-i18next';

import { Body1, Stack } from '@myphx-engineering/phx-design-system';

type LillyPharmacyInfo = {
    name: string;
    npi: string;
    ncpdp: string;
};

type VerifySwitchPrescriptionPharmacyDetailsProps = {
    pharmacy: LillyPharmacyInfo;
};

export const VerifySwitchPrescriptionPharmacyDetails = ({
    pharmacy,
}: VerifySwitchPrescriptionPharmacyDetailsProps) => {
    const { t } = useTranslation();

    return (
        <Stack gap="xxxs">
            <Body1 bold>{t('verifySwitchPage.pharmacy.heading')}</Body1>

            <Body1>{pharmacy.name}</Body1>
            <Body1>NPI: {pharmacy.npi}</Body1>
            <Body1>NCPDP: {pharmacy.ncpdp}</Body1>
        </Stack>
    );
};
